import wizardApi from '../data/wizardApi';


const getCategoryOptions = () => {
  return wizardApi.getCategoryOptions();
};

const getFlavourOptions = (category: string, flavours: string[]) => {
  return wizardApi.getFlavourOptions(category, flavours);
};

const getTasteOptions = (category: string, flavours: string[], tastes: string[]) => {
  return wizardApi.getTasteOptions(category, flavours, tastes);
};

const getMouthfeelOptions = (category: string, flavours: string[], tastes: string[], mouthfeels: string[]) => {
  return wizardApi.getMouthfeelOptions(category, flavours, tastes, mouthfeels);
};

const wizardService = {
  getCategoryOptions,
  getFlavourOptions,
  getTasteOptions,
  getMouthfeelOptions,
};


export default wizardService;
